$(function() {
	if (!($body.hasClass('single-post') || $body.hasClass('single-room') || $body.hasClass('single-press') || $body.hasClass('single-special') || $body.hasClass('single-shop') || $body.hasClass('single-event')))
		return;

	initializeSlick('.post_hero', {
		accessibility: true,
		slide: '.slide',
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		nextArrow: '<button class="slider_arrow next_arrow">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow">Previous</button>',
	});

	var collapseOthers = function(keep) {
		_.each(navs, function(nav) {
			if (keep != nav) {
				nav.api.hideMenu();
			}
		})
	}

	var socialNav = $('#share div.menu').accessibleMenu($('#share > button'), {
		menuItemSelector: 'li button',
		orientation: 'vertical',
		onItemExpanded: function(item, parent) {
			collapseOthers(socialNav);
		},
		onItemCollapsed: function(item, parent) {
		}
	});

	var categoriesNav = $('#categories .menu').accessibleMenu($('#categories button'), {
		menuItemSelector: 'a',
		orientation: 'vertical',
		onItemExpanded: function(item, parent) {
			collapseOthers(categoriesNav);
		},
		onItemCollapsed: function(item, parent) {
		}
	});

	var archivesNav = $('#archives .menu').accessibleMenu($('#archives button'), {
		menuItemSelector: 'a',
		orientation: 'vertical',
		onItemExpanded: function(item, parent) {
			collapseOthers(archivesNav);
		},
		onItemCollapsed: function(item, parent) {
		}
	});

	var searchNav = $('#post_search');
	// .accessibleScaffold({
	// 	toggleControl: '#post_search button',
	// 	roleWrapper: 'nav',
	// 	ariaRole: 'form',
	// 	items: 'input',
	// 	onActivate: function() {
	// 		searchNav.addClass('searching');
	// 	},
	// 	onDeactivate: function() {
	// 	}
	// });

	searchNav.on("click keypress", function(){
		searchNav.addClass('searching');
	});

	searchNav.find('#search_input').keypress(function(e) {
		if (e.key == 'Enter') {
			var val = $(this).val();
			if (val) {
				window.location = '/?s=' + val + '&t=' + ($(this).attr('data-type') || 'post');
			}
			return false;
		}
	}).blur(function(e) {
		searchNav.removeClass('searching');
		searchNav.api.deactivate();
	});

	var navs = [socialNav, categoriesNav, archivesNav];
	$('#share ul').addClass('expanded');


	if ($('.single-post').length || $('.single-press').length) {
		// Keep menu on screen as long as it doesn't overlap footer
		$(window).load(function() {
			var postHero = $('.post_hero');
			var heroTop = postHero.length ? postHero.offset().top : 0;
			var contentHeight = $('.page_body').height();
			var blogNav = $('#blog_nav');
			var blogNavWrapper = $('.aside_wrapper');
			var initialTop = blogNavWrapper.css('top');

			$(window).scroll(function() {
				var heroTopInViewport = heroTop - $(window).scrollTop();
				var scrollTop = $(window).scrollTop();

				if (scrollTop + 700 > contentHeight) {
					blogNavWrapper.removeClass('attached');
					blogNavWrapper.css('top', contentHeight - 410);
				} else if (heroTopInViewport < $window.height()/2 - blogNav.outerHeight()/2) {
					blogNavWrapper.addClass('attached');
					blogNavWrapper.css('top', '');
				} else {
					blogNavWrapper.removeClass('attached');
					blogNavWrapper.css('top', heroTop);
				}
			});
		})
	}
});